import { ButtonVariantType } from "../../Common/UI/Types";

export type AlertType = "error" | "information" | "warning";

export enum ErrorAlertType {
  ERROR = "error",
  INFORMATION = "information",
  WARNING = "warning"
}

export interface IErrorAlertObject {
  title: string;
  message: string[];
  type?: AlertType;
  actionButtonText?: string;
  cancelButtonText?: string;
  buttonVarient?: ButtonVariantType;
  actionClick?: () => void | Promise<void>;
}

export interface IInitialState {
  openErrorAlert: boolean;
  error: IErrorAlertObject;
}
